import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FujairahTextImage from "../components/truck-rental-fujairah/FujairahTextImage";
import FujairahTextSection from "../components/truck-rental-fujairah/FujairahTextSection";
import FujairahFaq from "../components/truck-rental-fujairah/FujairahFaq";
import VanRentalTable from "../components/van-rental-dubai/VanRentalTable";

import { chillerVanDubaiInvestmentParkSections } from "../components/chiller-van-dubai-investment-park/chillerVanDubaiInvestmentParkSections";
import "../components/truck-rental-fujairah/truck-rental-fujairah.css";
import "../components/van-rental-dubai/van-rental-dubai.css";
import "../components/chiller-van/chiller-van.css";

const ChillerVanForRentInDubaiInvestmentPark = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "cvd-hero":
        return (
          <ContactHero
            key={index}
            variant="chiller-van"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvd-text-image":
        return (
          <FujairahTextImage
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            altBg={section.altBg}
          />
        );

      case "cvd-text-only":
        return (
          <FujairahTextSection
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvd-table":
        return (
          <VanRentalTable
            key={index}
            title={section.title}
            description={section.description}
            intro={section.intro}
            columns={section.columns}
            rows={section.rows}
            notes={section.notes}
            background={section.background}
          />
        );

      case "cvd-faq":
        return (
          <FujairahFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Van Rental in Dubai Investment Park | AED 300/Day</title>
        <meta name="description" content="Chiller van rental in Dubai Investment Park — vans staged at your factory dock before the batch completes. 0°C to 8°C for DIP 1 and DIP 2 production and cold store runs." />
        <link rel="canonical" href="https://chillerfleet.com/chiller-van-for-rent-in-dubai-investment-park" />
        <meta property="og:title" content="Chiller Van Rental in Dubai Investment Park | AED 300/Day" />
        <meta property="og:description" content="Chiller van rental in Dubai Investment Park — vans staged at your factory dock before the batch completes. 0°C to 8°C for DIP 1 and DIP 2 production and cold store runs." />
        <meta property="og:url" content="https://chillerfleet.com/chiller-van-for-rent-in-dubai-investment-park" />
        <meta name="twitter:title" content="Chiller Van Rental in Dubai Investment Park | AED 300/Day" />
        <meta name="twitter:description" content="Chiller van rental in Dubai Investment Park — vans staged at your factory dock before the batch completes. 0°C to 8°C for DIP 1 and DIP 2 production and cold store runs." />
      </Helmet>

      {chillerVanDubaiInvestmentParkSections.map(renderSection)}
    </>
  );
};

export default ChillerVanForRentInDubaiInvestmentPark;
